export const ActionTypes = {
  // Derivate View
  SET_MODELTYPE_COLORS: 'SET_MODELTYPE_COLORS',
  SET_MODELTYPEBASIC_PDIP_LIST: 'SET_MODELTYPEBASIC_PDIP_LIST',
  RECEIVE_MODEL_TYPE_BASIC_EXTRA_LINKS:'RECEIVE_MODEL_TYPE_BASIC_EXTRA_LINKS',

  // Base Options View
  SET_SER_CATEGORIES: 'SET_SER_CATEGORIES',
  SET_NON_SER_CATEGORIES: 'SET_NON_SER_CATEGORIES',
  SET_OPTION_BASIC_TABLE_SORT: 'SET_OPTION_BASIC_TABLE_SORT',
  SET_OPTION_BASIC_PDIP_LIST: 'SET_OPTION_BASIC_PDIP_LIST',
  RECEIVE_BASE_OPTIONS_AREA_EXTRA_LINKS:
    'RECEIVE_BASE_OPTIONS_AREA_EXTRA_LINKS',

  // Options View
  CHANGE_OPTIONSVIEW_USER_SETTINGS: 'CHANGE_OPTIONSVIEW_USER_SETTINGS',
  SET_OPTION_TABLE_SORT: 'SET_OPTION_TABLE_SORT',
  RECEIVE_PSL_AREA_EXTRA_LINKS: 'RECEIVE_PSL_AREA_EXTRA_LINKS',
  SET_HIDE_EMPTY_ASSIGN_ROWS_AND_COLUMNS:
    'SET_HIDE_EMPTY_ASSIGN_ROWS_AND_COLUMNS',

  // Support View
  RECEIVE_SUPPORTAREA_LINKS: 'RECEIVE_SUPPORTAREA_LINKS',
  RECEIVE_ACTIVE_FAQS: 'RECEIVE_ACTIVE_FAQS',

  // Admin View
  RECEIVE_USERS: 'RECEIVE_USERS',
  RECEIVE_GROUPS: 'RECEIVE_GROUPS',
  RECEIVE_PROMT_GROUPS: 'RECEIVE_PROMT_GROUPS',
  RECEIVE_ROLES: 'RECEIVE_ROLES',
  RECEIVE_PRIVILEGES: 'RECEIVE_PRIVILEGES',
  RECEIVE_FLAGS: 'RECEIVE_FLAGS',
  RECEIVE_NEWS: 'RECEIVE_NEWS',
  RECEIVE_FAQS: 'RECEIVE_FAQS',
  RECEIVE_IMPORTER_LIST: 'RECEIVE_IMPORTER_LIST',
  RECEIVE_ADMINAREA_LINKS: 'RECEIVE_ADMINAREA_LINKS',
  RECEIVE_SPEC_CONFIGS: 'RECEIVE_SPEC_CONFIGS',
  RECEIVE_SPECS: 'RECEIVE_SPECS',
  RECEIVE_ACTIVE_NEWS: 'RECEIVE_ACTIVE_NEWS',
  RECEIVE_MODELYEAR_CATEGORIES: 'RECEIVE_MODELYEAR_CATEGORIES',
  UNLOAD_MODELYEAR_CATEGORIES: 'UNLOAD_MODELYEAR_CATEGORIES',
  CHANGE_ACTIVE_ACCESSTAB: 'CHANGE_ACTIVE_ACCESSTAB',
  RECEIVE_CNR_LANGUAGES: 'RECEIVE_CNR_LANGUAGES',

  // Tech View
  RECEIVE_DERIVATES: 'RECEIVE_DERIVATES',
  UNLOAD_DERIVATES: 'UNLOAD_DERIVATES',
  RECEIVE_TECHNICAL_DATA: 'RECEIVE_TECHNICAL_DATA',
  UNLOAD_TECHNICAL_DATA: 'UNLOAD_TECHNICAL_DATA',
  UNLOAD_TECHNICAL_DATA_DERIVATES: 'UNLOAD_TECHNICAL_DATA_DERIVATES',
  RECEIVE_TECHNICAL_DATA_DERIVATES: 'RECEIVE_TECHNICAL_DATA_DERIVATES',

  // Approval View
  RECEIVE_APPROVAL_LIST: 'RECEIVE_APPROVAL_LIST',
  UPDATE_OPEN_APPROVALS_COUNT: 'UPDATE_OPEN_APPROVALS_COUNT',

  // General
  LOGIN: 'LOGIN',
  USER_INFO_LOADED: 'USER_INFO_LOADED',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  CHANGE_TABLE_MODE: 'CHANGE_TABLE_MODE',
  ADD_LOCATION_TRANSLATION: 'ADD_LOCATION_TRANSLATION',
  ADD_LOADING_MESSAGE: 'ADD_LOADING_MESSAGE',
  REMOVE_LOADING_MESSAGE: 'REMOVE_LOADING_MESSAGE',
  SET_LOADING_MUTEX: 'SET_LOADING_MUTEX',
  SET_FACTORY_USER_SETTINGS: 'SET_FACTORY_USER_SETTINGS',
  ADD_RECENT_DOCUMENT: 'ADD_RECENT_DOCUMENT',
  RECEIVE_INIT_DATA: 'RECEIVE_INIT_DATA',
  RECEIVE_BASE_LINKS: 'RECEIVE_BASE_LINKS',
  RECEIVE_WORKFLOW_LIST: 'RECEIVE_WORKFLOW_LIST',
  DYNTABLE_SELECTEDIDLIST: 'DYNTABLE_SELECTEDIDLIST',
  DYNTABLE_ROLLBACK: 'DYNTABLE_ROLLBACK',
  DYNTABLE_RELOAD: 'DYNTABLE_RELOAD',
  // KumaView
  RECEIVE_KUMA_EXTRA_LINKS: 'RECEIVE_KUMA_EXTRA_LINKS',
  ISKUMA_MANAGER_ROLE_ONLY:'ISKUMA_MANAGER_ROLE_ONLY',
  RECEIVED_KUMA_REQUIREMENTS:'RECEIVED_KUMA_REQUIREMENTS',
  MAINTENANCE_STATUS:'MAINTENANCE_STATUS',
  RECEIVE_TRANSLATION_SERVICE: 'RECEIVE_TRANSLATION_SERVICE'
};



// WEBPACK FOOTER //
// ./src/redux/actions/ActionTypes.ts